// @flow
import SettingsDataProvider from './settings-data-provider';
import useSettings from './use-settings';
import { defaultSettings } from './settings-context';
import useSettingsContext from './use-settings-context';

export default SettingsDataProvider;
export { useSettings, defaultSettings, useSettingsContext };
